module.exports = __webpack_public_path__ + "img/lify.e33074d2.svg";